import { SearchOutlined } from '@mui/icons-material'
import { Box, Button, CircularProgress, Divider, IconButton, InputAdornment, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import PageContainer from '../components/PageContainer'
import { searchCategories, searchResults } from '../util'
import Chart from 'react-apexcharts'
import { DataGrid } from '@mui/x-data-grid'
import PivotTableUI from 'react-pivottable/PivotTableUI';

const DomainView = () => {
    const [ searching, setSearching ] = useState(false)
    const [ data, setData ] = useState({})
    const [ category, setSelectedCategory ] = useState(null)
    const params = useParams();

    
    const columns = [
        { field: 'title', headerName: 'Institution Name', width: 1000 },
        { field: 'frequency', headerName: 'Institution Name', width: 300 },
    ];

    useEffect(() => {
        if(params?.domain) {
            const cat = searchCategories.find((cat) => cat.title === String(params?.domain)?.replaceAll('-', ' '));
            setData(cat)

            if(params?.category) {
                setSelectedCategory(String(params?.category)?.replaceAll('-', ' '))
            }
        }
    }, [params])
    
    return (
        <PageContainer>
            <section className="inner-banner parallax-section">
                <div className='overlay' style={{ padding: '10rem 0 12rem' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12 text-center">
                                <h5 className="wow bounceIn mb-1" data-wow-delay="0.4s">{data?.title}</h5>
                                <h1 className="wow fadeInUp text-uppercase conference mb-3 mt-0" data-wow-delay="0.4s">{category}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <section className="blog_area single-post-area section-padding domain-view">
                <div className="container">
                    <div className="row">
                        {
                            category ?
                            <>
                                <div className="col-12 text-left">
                                    <ul>
                                        {
                                            data?.subCategories?.find(({ title }) => title == category)?.subCategories?.map((cat) => (
                                                <li>
                                                    <Link to={`/data-domain/${String(data.title).replaceAll(' ', '-')}/${String(cat.title).replaceAll(' ', '-')}`}>
                                                        <p>{cat?.title}</p>
                                                    </Link>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                    {/* <Box my={5}>
                                        <div style={{ height: 500, width: '100%', textAlign: 'center' }}>
                                            <DataGrid
                                                rows={
                                                    data?.subCategories?.find(({ title }) => title == category)?.subCategories || []
                                                }
                                                columns={columns}
                                                getRowId={row => row?.title}
                                                pageSize={50}
                                                autoHeight
                                                rowsPerPageOptions={[50]}
                                                checkboxSelection={true}
                                                disableSelectionOnClick
                                            />
                                        </div>
                                    </Box> */}
                                </div>
                            </>
                            :
                            <>
                                <div className="col-12 text-justify text-grey f-16">
                                    {data?.details}
                                </div>
                                <div className="col-12 text-justify mt-2">
                                    <h4>Data Selectors</h4>
                                    <ul>
                                        {
                                            data?.subCategories?.map((cat) => (
                                                <li>
                                                    <p>{cat?.title}</p>
                                                    <ul>
                                                        {
                                                            data?.subCategories?.find(({ title }) => title == cat?.title)?.subCategories?.map((cat) => (
                                                                <li>
                                                                    <Link to={`/view/${String(cat.title).replaceAll(' ', '-')}?reportSection=${cat?.reportSection || ''}`}>
                                                                        <p>{cat?.title}</p>
                                                                    </Link>
                                                                </li>
                                                            ))
                                                        }
                                                    </ul>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </section>

        </PageContainer>

    )
}

export default DomainView